import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import ContactSettingComponent from '../components/contactSettingComponent';
import {getAllContactSettings, updateContactCallingNumber,
    UpdateDispatcherCallingNumber, UpdateSupportCallingNumber, UpdateSupportEmailAddress,
    clearStore, updateEnableDirectCalling} from '../action/contactSettingAction';

export class ContactSettingContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllContactSettings();
    }
    getSettings = () => {
        this.props.actions.getAllContactSettings(
            this.props.dispatch
        )
    }
    clear = () =>{
        this.props.actions.clearStore(
            this.props.dispatch
        )
    }
    updateContactCallingNum = (value) =>{
        this.props.actions.updateContactCallingNumber(
            value,
            this.props.dispatch
        )
    }
    updateDispatcher = (value) =>{
        this.props.actions.UpdateDispatcherCallingNumber(
            value,
            this.props.dispatch
        )
    }
    updateSupportNumber =(value) =>{
        this.props.actions.UpdateSupportCallingNumber(
            value,
            this.props.dispatch
        )
    }
    updateSupportEmail = (value) => {
        this.props.actions.UpdateSupportEmailAddress(
            value,
            this.props.dispatch
        )
    }
    updateDirectCalling = (value) => {
        this.props.actions.updateEnableDirectCalling(
            value,
            this.props.dispatch
        )
    }
    render(){
        return(
            <div>
                <ContactSettingComponent
                    getAllContactSettingDetails = {this.props.ContactSettingData}
                    updateContact = {this.updateContactCallingNum}
                    getAllSettings = {this.getSettings}
                    updateDispatcherNum = {this.updateDispatcher}
                    updateSupportNumber = {this.updateSupportNumber}
                    updateSupportEmail = {this.updateSupportEmail}
                    clearState = {this.clear}
                    updateDirectCalling = {this.updateDirectCalling}
                >
                </ContactSettingComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllContactSettings,
            updateContactCallingNumber,
            UpdateDispatcherCallingNumber,
            UpdateSupportCallingNumber,
            UpdateSupportEmailAddress,
            clearStore,
            updateEnableDirectCalling
        },
            dispatch)
    };
}
function mapStateToProps({ ContactSettingReducer }) {
    console.log(ContactSettingReducer);
    return {
        ContactSettingData : {
            errorCode : ContactSettingReducer.errorCode,
            statusCode : ContactSettingReducer.statusCode,
            allSetting : ContactSettingReducer.allSetting,
            message : ContactSettingReducer.message,
            responseValue : ContactSettingReducer.responseValue
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactSettingContainer));
